import { StopCircleIcon } from '@heroicons/react/16/solid';
import { CheckCircleIcon, XMarkIcon } from '@heroicons/react/20/solid';
import { MicrophoneIcon } from '@heroicons/react/24/outline';
import { Dispatch, SetStateAction } from 'react';
import { Button, Loading } from 'react-daisyui';
import { tAttachment } from '../../../../../../Chat.types.ts';
import { useAudioRecorderAction } from './AudioRecorderAction.hooks.tsx';
import './AudioRecorderAction.styles.scss';

export default function AudioRecorderAction(props: {
  setNewAttachments?: Dispatch<SetStateAction<tAttachment[] | undefined>>;
}) {
  const { setNewAttachments } = props;
  const {
    onMicrophoneClick,
    showRecorder,
    formatTime,
    recording,
    seconds,
    loading,
    onDeleteAudio,
    onStopAudio,
  } = useAudioRecorderAction();

  return (
    <div className="AudioRecorderAction">
      {loading ? (
        <Loading className="AudioRecorderAction__Icon" />
      ) : (
        <Button
          color="ghost"
          onClick={() => {
            onMicrophoneClick(setNewAttachments);
          }}
          size="xs"
          className="MessageBar__Button"
        >
          <MicrophoneIcon className="MessageBar__Icon" />
        </Button>
      )}
      {showRecorder && (
        <div className="AudioRecorderAction__Recorder">
          <div className="AudioRecorderAction__Recorder__Microphone">
            <MicrophoneIcon className="AudioRecorderAction__Recorder__Microphone__Icon" />
          </div>
          <div>{formatTime(seconds)}</div>
          {recording ? (
            <StopCircleIcon
              className="AudioRecorderAction__Recorder__Stop"
              onClick={onStopAudio}
            />
          ) : (
            <div className="AudioRecorderAction__Recorder__Actions">
              <XMarkIcon
                className="AudioRecorderAction__Recorder__Stop"
                onClick={onDeleteAudio}
              />
              <CheckCircleIcon
                className="AudioRecorderAction__Recorder__Check"
                onClick={() => {
                  onMicrophoneClick(setNewAttachments);
                }}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}
